import * as api from '../../services/contact'

export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const FETCH_CONTACT = 'FETCH_CONTACT';
export const FETCH_CTTGROUPS = 'FETCH_CTTGROUPS';
export const FETCH_CTTGPS = 'FETCH_CTTGPS';


export const fetchContact = (userId,id) => ({
    type: FETCH_CONTACT,
    payload: {
        promise: api.findContact({id: id,userId:userId})
    }
});


export const fetchCttgroups = () => ({
    type: FETCH_CTTGROUPS,
    payload: {
        promise: api.findCttgroups()
    }
});


export const fetchContacts = (params, pagination, sort, extra) => {

    return {
        type: FETCH_CONTACTS,
        payload: {
            promise: api.findContacts(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};

export const fetchCttgps = (params, pagination, sort, extra) => {

    return {
        type: FETCH_CTTGPS,
        payload: {
            promise: api.findCttgps(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/contact.js